// extracted by mini-css-extract-plugin
module.exports = {"Typography":"Typography_Typography__3ps9A","t14":"Typography_t14__3-1Fh","t16":"Typography_t16__38Lke","Subtext":"Typography_Subtext__3Scz2"};